import { render, staticRenderFns } from "./FeatureFlagSwitcher.vue?vue&type=template&id=789a21a4"
import script from "./FeatureFlagSwitcher.vue?vue&type=script&lang=js"
export * from "./FeatureFlagSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports